import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_ONLY_FORMAT, STALE_DATA_DAYS } from '../constants';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export const formatDate = (value: string | null | undefined): string => {
	if (!value) return '—';
	const date = dayjs(value);
	if (!date.isValid()) return value;
	// date-only values (partition dates, erasure dates) have no time to show
	return DATE_ONLY.test(value) ? date.format(DATE_ONLY_FORMAT) : date.format(DATE_FORMAT);
};

export const isStale = (dataAsOf: string | null | undefined): boolean => {
	if (!dataAsOf) return false;
	const date = dayjs(dataAsOf);
	return date.isValid() && dayjs().diff(date, 'day') > STALE_DATA_DAYS;
};

export const truncate = (value: string, max: number): string => (value.length > max ? `${value.slice(0, max - 1)}…` : value);
